export default class Parallax {
  constructor() {
    this.$elements = [...document.querySelectorAll('[data-parallax]')]
    if (!this.$elements) return;
    this.init();
  }
  
  init() {
    this.$elements.forEach(el => {
      switch (el.dataset.parallax) {
        case 'text':
          this.parallaxText(el);
          break;
        case 'img':
          this.parallaxImg(el);
          break;
      }
    });
  }

  parallaxText(el) {
    gsap.set(el, { xPercent: el.dataset.startX ?? 10 })
    gsap.to(el, {
      xPercent: 0,
      ease: 'none',
      scrollTrigger: {
        trigger: el,
        start: 'top bottom',
        end: 'bottom 50%',
        scrub: 3,
      },
    });
  }

  parallaxImg(el) {
    gsap.set(el, { yPercent: el.dataset.startX ?? 5 })
    gsap.to(el, {
      yPercent: 0,
      ease: 'none',
      scrollTrigger: {
        trigger: el,
        start: 'top bottom',
        end: 'bottom 50%',
        scrub: 3,
      },
    });
  }
}
